import React from 'react';

import FeaturedItems from './FeaturedItems'
import FeaturedItemMain from './FeaturedItemMain'

const Featured = ({featured, playlists}) => {
    return (
        <div className="featured">
            <FeaturedItemMain item={featured}/>
            <div className="featured__text">
                <h3>Featured</h3>
                <p>This week</p>
            </div>
            <FeaturedItems items={playlists}/>
        </div>
    );
}

export default Featured;
